import { getUserLocale } from '~/utils/getUserLocale';
import { setElementStyle } from '~/utils/setElementStyle';
import { renderErrorMessageContent } from './renderErrorMessageContent';

const XMarkIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8332 1.34169L10.6582 0.166687L5.99984 4.82502L1.3415 0.166687L0.166504 1.34169L4.82484 6.00002L0.166504 10.6584L1.3415 11.8334L5.99984 7.17502L10.6582 11.8334L11.8332 10.6584L7.17484 6.00002L11.8332 1.34169Z" fill="#1A1A1A"/>
</svg>`;

const initialErrorTitleCS = 'Nepodařilo se nám spustit vyhledávání.';
const initialErrorContentCS = `Pokud problém přetrvává, napište nám na <a href="mailto:info@searchready.cz" style="text-decoration: underline;">info@searchready.cz.</a>`;
const initialErrorTitleEN = 'We were unable to start the search.';
const initialErrorContentEN = `If the problem persists, please contact us at <a href="mailto:info@searchready.cz" style="text-decoration: underline;">info@searchready.cz.</a>`;

const initialErrorTitle = getUserLocale() === 'cs' ? initialErrorTitleCS : initialErrorTitleEN;
const initialErrorContent = getUserLocale() === 'cs' ? initialErrorContentCS : initialErrorContentEN;

/**
 * React component to be used in error boundary on the top level of the application.
 * Is rendered when error occurs before application is fully initialized and layout is shown.
 */
export const InitialErrorMessage: React.FC<{ setNotRender: () => void }> = ({ setNotRender }) => {
    return (
        <div
            className="sr-error-container"
            style={{
                position: 'fixed',
                top: '10px',
                left: '0',
                right: '0',
                zIndex: '9999',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div
                id="sr-error-message-box"
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    backgroundColor: '#fbebad',
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
                    color: '#000',
                    fontSize: '1rem',
                    padding: '20px',
                }}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: renderErrorMessageContent(initialErrorTitle, initialErrorContent),
                    }}
                />
                <button
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        cursor: 'pointer',
                        padding: '10px',
                        border: '0',
                        background: 'none',
                    }}
                    onClick={setNotRender}
                    dangerouslySetInnerHTML={{
                        __html: XMarkIcon,
                    }}
                />
            </div>
        </div>
    );
};

/**
 * Plain JS function to render error message if error occurs during application initialization.
 */
export function renderInitialErrorMessage() {
    const errorContainer = document.createElement('div');
    errorContainer.id = 'sr-error-container';
    setElementStyle(errorContainer, {
        position: 'fixed',
        top: '10px',
        left: '0',
        right: '0',
        zIndex: '9999',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    });

    errorContainer.innerHTML = `
    <div id="sr-error-message-box" style="position: relative;display: flex;flex-direction: row;align-items: flex-start;background-color: #fbebad;box-shadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)';color: #000;font-size: 1rem;padding: 20px;">
        ${renderErrorMessageContent(initialErrorTitle, initialErrorContent)}
        <div style="position: absolute; top: 0; right: 0; cursor: pointer; padding: 10px;" onclick="document.getElementById('sr-error-container').remove();">
            ${XMarkIcon}
        </div>
    </div> `;
    document.body.appendChild(errorContainer);
}
